var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");Object.defineProperty(exports,"__esModule",{value:true});exports.default=void 0;var _slug=_interopRequireDefault(require("@24i/nxg-sdk-smartott/src/pages/[slug]"));var _default=

_slug.default;exports.default=_default;